/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.10.2015
 * Copyright: xdot GmbH 2015
 */

let lastId = 0;

export function generateId(prefix) {
    return (prefix || 'uid_') + lastId++;
}

export default {
    generateId
};



// WEBPACK FOOTER //
// ./js/utils/uid-util.js